export default {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: "vrchitecht.firebaseapp.com",
  databaseURL: "https://vrchitecht.firebaseio.com",
  projectId: "vrchitecht",
  storageBucket: "vrchitecht.appspot.com",
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
};
